import { getApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";

// =============================== BASE  ===============================  //
const app = getApp();

export const REF = {
  NAME: "(default)",
  COLLECTIONS: {
    PAPER: "paper",
    SETTING: "setting",
    HACKER: "hacker",
  },
};

export const getRefs = () => {
  const firestore = getFirestore(app, REF.NAME);
  const CREF = {
    paper: collection(firestore, REF.COLLECTIONS.PAPER),
    setting: collection(firestore, REF.COLLECTIONS.SETTING),
    hacker: collection(firestore, REF.COLLECTIONS.HACKER),
  };
  return CREF;
};
